/**
 * Created by jacmai on 6/30/2017.
 */
define(["marionette", "./template/variablePromptTemplate.html"], function (
  Marionette,
  VariablePromptTemplate,
) {
  var VariablePromptView = {};

  VariablePromptView.variablePromptLayout = Marionette.Layout.extend({
    template: VariablePromptTemplate,
    modelEvents: {
      "change:name": function () {
        //update the name of the variable in the header
        this.$el.find("div.main-header > h1").text(this.model.get("name"));
      },
    },
    regions: {
      menu: "#promptMenu",
      response: "#promptResponse",
    },
    setPromptTitle: function (title) {
      this.$el.find("h3#selectedPrompt").text(title);
    },
  });

  return VariablePromptView;
});
